import { StyleManagerConfig } from 'grapesjs';

export const stylesConfig: Partial<StyleManagerConfig> = {
  sectors: [
    {
      name: 'Размеры',
      open: false,
      buildProps: [
        'width',
        'height',
        'min-width',
        'min-height',
        'max-width',
        'max-height',
        'overflow',
        'overflow-x',
        'overflow-y',
        'aspect-ratio',
        'object-fit',
        'object-position',
      ],
    },
    {
      name: 'Отступы',
      open: false,
      buildProps: ['padding', 'margin'],
    },
    {
      name: 'Текст',
      open: false,
      buildProps: ['color', 'font-size', 'line-height', 'font-weight', 'text-align', 'letter-spacing'],
    },
    {
      name: 'Фон',
      open: false,
      buildProps: ['clip-path', 'transform'],
      properties: [
        {
          id: 'background',
          name: 'Изображение',
          property: 'background',
          type: 'text',
          defaults: 'none',
        },
        {
          type: 'color',
          name: 'Цвет фона',
          property: 'background-color',
        },
        {
          id: 'background-repeat',
          name: 'background-repeat',
          property: 'background-repeat',
          type: 'text',
        },
        {
          id: 'background-position',
          name: 'background-position',
          property: 'background-position',
          type: 'text',
        },
        {
          id: 'background-size',
          name: 'background-size',
          property: 'background-size',
          type: 'text',
        },
      ],
    },
    {
      name: 'Границы',
      open: false,
      buildProps: ['border-radius', 'border', 'box-shadow'],
    },
    {
      name: 'Позиционирование',
      open: false,
      buildProps: ['position', 'top', 'right', 'bottom', 'left', 'z-index'],
    },
    {
      name: 'Отображение',
      open: false,
      properties: [
        {
          id: 'display',
          name: 'Display',
          property: 'display',
          type: 'select',
          options: [
            { id: 'block', value: 'block', label: 'block' },
            { id: 'inline', value: 'inline', label: 'inline' },
            { id: 'inline-block', value: 'inline-block', label: 'inline-block' },
            { id: 'flex', value: 'flex', label: 'flex' },
            { id: 'grid', value: 'grid', label: 'grid' },
            { id: 'none', value: 'none', label: 'none' },
          ],
        },
      ],
    },
    {
      name: 'Flex',
      open: false,
      buildProps: ['flex-direction', 'flex-wrap', 'justify-content', 'align-items', 'align-content', 'gap'],
    },
    {
      name: 'Grid',
      open: false,
      properties: [
        'grid-template-columns',
        'grid-template-rows',
        'grid-template-areas',
        'grid-auto-columns',
        'grid-auto-rows',
        'grid-auto-flow',
        'gap',
        'row-gap',
        'column-gap',
      ],
    },
  ],
};
